import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon28: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#32BBC3"
        d="M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10a.5.5 0 0 1 0-1 9 9 0 0 0 9-9 9 9 0 0 0-9-9 .5.5 0 0 1 0-1Zm.5 4a.5.5 0 0 1 .5.5V10h5.5a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5Zm-3-2h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1Zm0 15h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1Zm0-12h-6a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1Zm0 3h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1Zm0 3h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1Zm0 3h-6a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1Z"
      />
    </Svg>
  )
}
